module.exports = __webpack_public_path__ + "img/background1-mobie-hk.a4392c77.jpg";